<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
import { debounce } from '@/utils'
import { markRaw } from 'vue'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    data:{
      type: Array,
       default: ()=>{
        return []
      }
    },
  },
  data() {
    return {
      chart:null
    }
  },
  watch:{
    'data':{
      handler() {
         this.refreshData()
      },
      deep:true
    },
  },
  mounted() {
    this.refreshData()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 500)
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeUnmount() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
        this.chart = markRaw(echarts.init(this.$el))
        this.setOption()
    },
    setOption(){
        this.chart.setOption({
          tooltip:{
            trigger: 'axis',
            axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          grid:{
              top:40,
              left:40,
              right:18,
              bottom:50,
          },
          xAxis: {
              type: 'time',
              boundaryGap: false,
              axisLabel:{
                  color:'#fff'
              }
          },
          yAxis: {
              name:'在线率（%）',
              nameTextStyle:{
                  color:'#fff'
              },
              min:0,
              max:100,
              type: 'value',
              axisLabel:{
                  color:'#fff'
              },
              splitLine:{
                  show:false
              }
          },
          series: [
              {
                  name:'设备在线率',
                  data: this.data,
                  type: 'line',
                  areaStyle: {
                      color:{
                          type: 'linear',
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [{
                              offset: 0, color: 'rgba(30,247,255,0.39)' // 0% 处的颜色
                          }, {
                              offset: 1, color: 'rgba(30,247,255,0)' // 100% 处的颜色
                          }],
                          global: false // 缺省为 false
                      }
                  },
                  lineStyle:{
                      color:'#36E8F8',
                  },
                  itemStyle:{
                      color:'#1EF7FF', 
                  }
              }
          ]
        })
          
    },
    refreshData(){
        //刷新数据
        if(this.chart){
          this.setOption();  
        }else{
          this.initChart()
        }  
    }
  }
}

</script>